import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=87de390c&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=87de390c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87de390c",
  null
  
)

export default component.exports